import React, { Component } from "react";
import axiosInstance from "../../api/utils/axiosInstance";
import EntryForm4 from "../../components/EntryForms/EntryForm4/EntryForm4";
import { connect } from "react-redux";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import {
  handleUserInput,
  handleMappedUserInput,
} from "../../helperFunctions/EntryFormHelperFunctions/userInputHandlers";
import {
  countryAutocompleteHandler,
  countyAutocompleteHandler,
  cityAndMuncipalityAutocomplete,
  districtAutocompleteHandler,
} from "../../helperFunctions/EntryFormHelperFunctions/autocompleteHelpers";
import { handleDayPicker } from "../../helperFunctions/EntryFormHelperFunctions/datePickerHelper";
import {
  validateRequiredFields,
  validateArrayFields,
} from "../../helperFunctions/validationHelpers/validateRequiredFields";
import Spinner from "../../components/UI/Spinner/Spinner";
import fetchFormsApi from "../../api/formsApi/fetchFormsApi";
import { purgeUpdateAndRedirect } from "../../helperFunctions/purgeUpdateAndRedirect";
import { PURGE_UPDATE } from "../../constants/constants";

class RegistarRevizorskihVjezbenika extends Component {
  state = {
    update: false,
    error: false,
    loader: false,
    requestsLoaded: false,
    countryList: [],
    countryList: [],
    cityAndMuncipalityList: [],
    districtList: [],
    newFormData: {
      oznDokumenta: {
        oznDokumenta: "",
      },

      userData: {
        vrOsobe: "2",
        oib: "",
        ime: "",
        oznAkt: "",
        prezime: "",
        regBroj: "",
        requiredFieldsUserData: ["oib", "ime", "prezime"],
        oibValidated: false,
        tstampUnosa: null,
      },
      address: {
        vrAdr: "1",
        sifDrzave: "191",
        sifZupanije: "",
        nazZupanije: "",
        sifGrdOpc: "",
        nazGrdOpc: "",
        sifNaselja: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        nazivDrzave: "",
        requiredFieldsAddress: [
          "sifDrzave",
          "sifZupanije",
          "nazZupanije",
          "sifGrdOpc",
          "nazGrdOpc",
          "sifNaselja",
          "nazNaselja",
          "brPoste",
          "ulicaKbr",
        ],
      },
      reviserRegistration: [
        {
          vrVeze: "",
          idDrustva: "",
          oibIdBrojDrustva: "",
          id: 1,
          requiredFieldsReviserRegistration: ["vrVeze"],
          ime: "",
          datPocRo: "",
          datPocSo: "",
          prezime: "",
          nazDrustva: "",
          dataFetched: false,
          sifDrzave: "",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
          ///
          // vrVeze: "",
          // idDrustva: "",
          // idDrugaDrzava: "",
          // oibDrustva: "",
          // requiredFieldsReviserRegistration: ["vrVeze"],
          // id: 1,
          // oibValidated: false,
          // ime: "",
          // prezime: "",
          // nazDrustva: "",
          // dataFetched: false,
          // sifDrzave: "",
          // nazNaselja: "",
          // brPoste: "",
          // ulicaKbr: "",
          // web: "",
        },
      ],
      selectedDropdownValue: "",
      dropDownData: [
        {
          id: 1,
          value: "Vježbenik",
        },
      ],
    },
  };

  componentDidMount = () => {
    this.getCountryList();
  };

  getOsobaEdit = async (oznaka) => {
    const { idOsobe, vrOsobe } = this.props;

    const { data } = await axiosInstance.get(
      `/findOsoba?idOsobe=${idOsobe}&vrOsobe=${vrOsobe}&showHistory=false`
    );

    let reviserRegistration;
    if (data[3].length > 0) {
      reviserRegistration = data[3].map((element, index) => {
        return {
          funkcija:1,
          vrVeze: element.vrDrustva,
          idDrustva: element?.idDrustva || "",
          oibIdBrojDrustva: element?.oibIdBrojDrustva || "",
          id: index + 1,
          ime: element?.imeDrustva || "",
          prezime: element?.prezimeDrustva || "",
          nazDrustva: element?.nazivDrustva || "",
          dataFetched: true,
          sifDrzave: element?.idDrzaveDrustva || "",
          brPoste: element?.postanskiBrojDrustva || "",
          nazNaselja: element?.nazivNaseljaDrustva || "",
          ulicaKbr: element?.ulicaKbrDrustva || "",
          web: element?.web || "",
          requiredFieldsReviserRegistration: ["vrVeze"],
          datPocRo: element?.datPocRo || "",
          datPocSo: element?.datPocSo || "",
        };
      });
    } else {
      reviserRegistration = this.state.newFormData.reviserRegistration;
    }

    if (data[2].sifZupanije) {
      this.getCityAndMuncipalityList(data[2].sifZupanije);
    }
    if (data[2].sifGrdOpc) {
      this.getDistrictList(data[2].sifGrdOpc);
    }

    let oznDokumenta = {};

    if (oznaka) {
      oznDokumenta.oznDokumenta = oznaka;
    } else {
      oznDokumenta.oznDokumenta = data[4].oznDokumenta;
    }

    this.setState((prevState) => ({
      update: true,
      requestsLoaded: true,
      newFormData: {
        ...prevState.newFormData,
        oznDokumenta,
        userData: {
          ...prevState.newFormData.userData,
          oznAkt: data[1]?.oznAkt || "",
          idOsobe: data[1]?.idOsobe || "",
          oib: data[1]?.oib || "",
          ime: data[1]?.ime || "",
          prezime: data[1]?.prezime || "",
          regBroj: data[1]?.regBroj || "",
          oibValidated: true,
          tstampUnosa: data[1].tstampUnosa,
        },
        address: {
          ...prevState.newFormData.address,
          sifDrzave: String(data[2]?.sifDrzave) || "",
          sifZupanije: String(data[2]?.sifZupanije) || "",
          nazZupanije: data[2]?.nazZupanije || "",
          sifGrdOpc: String(data[2]?.sifGrdOpc) || "",
          nazGrdOpc: data[2]?.nazGrdOpc || "",
          sifNaselja: String(data[2]?.sifNaselja) || "",
          nazNaselja: data[2]?.nazNaselja || "",
          brPoste: data[2]?.brPoste || "",
          ulicaKbr: data[2]?.ulicaKbr || "",
        },
        reviserRegistration,
      },
    }));
  };

  getCountryList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/drzave");
    this.setState(
      {
        countryList: data,
      },
      () => {
        this.getCountyList();
      }
    );
  };

  checkIfUpdate = (url) => {
    return this.props.match.url.includes(url);
  };

  getCountyList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/zupanije");

    this.setState(
      {
        countyList: data,
      },
      () => {
        if (this.checkIfUpdate("/azuriraj/registar-revizorskih-vjezbenika")) {
          if (this.props.idOsobe != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          this.getOsobaEdit();
        } else if (
          this.checkIfUpdate(
            "/azuriraj-po-zahtjevu/registar-revizorskih-vjezbenika"
          )
        ) {
          if (this.props.idOsobe != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          const oznDokumenta = this.props.oznDokumenta;
          this.getOsobaEdit(oznDokumenta);
        } else {
          this.getDataFromUnosZahtjeva();
        }
      }
    );
  };

  getDataFromUnosZahtjeva = async () => {
    const { data } = await fetchFormsApi(
      `/request/${this.props.zahtjevAtrId}?isEdit=${false}`
    );

    this.setState(
      (prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          userData: {
            ...prevState.newFormData.userData,
            oibValidated: true,
            oib: data.oib,
            ime: data.ime,
            prezime: data.prezime,
          },
        },
      }),
      () => {
        this.disableLoader();
      }
    );
  };

  disableLoader = () => {
    this.setState({
      requestsLoaded: true,
    });
  };

  getCityAndMuncipalityList = async (countyId) => {
    const { data } = await axiosInstance.get(
      `/sifarnici/gradOpcina/${countyId}`
    );
    this.setState(
      {
        cityAndMuncipalityList: data,
      },
      () => { }
    );
  };

  getDistrictList = async (id) => {
    const { data } = await axiosInstance.get(`/sifarnici/naselja/${id}`);
    this.setState({ districtList: data }, () => { });
  };

  dropdownHandler = (e) => {
    e.persist();
    const id = e.target.id.replace(/[^0-9]/g, "");

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        reviserRegistration: [
          ...prevState.newFormData.reviserRegistration.map((element) => {
              return element;
          }),
        ],
      },
    }));
  };

  autocompleteCountryHandler = (values, objectData) => {
    this.setState(countryAutocompleteHandler(values, objectData));
  };

  mappedUserInputHandler = (e, objectData) => {
    e.persist();
    const { name } = e.target;

    this.setState(handleMappedUserInput(e, objectData), () => {
      if (
        objectData.group === "reviserRegistration" &&
        name === "oibIdBrojDrustva"
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.group]: [
              ...prevState.newFormData[objectData.group].map((element) =>
                element.id === objectData.id
                  ? {
                    //testirati
                    ...element,
                    sifDrzave: "",
                    nazNaselja: "",
                    brPoste: "",
                    ulicaKbr: "",
                    web: "",
                    dataFetched: false,
                    id: element.id,
                    idDrustva: "",
                    nazDrustva: "",
                  }
                  : element
              ),
            ],
          },
        }));
      }
    });
  };

  autocompleteCountyHandler = (values, objectData) => {
    this.setState(
      countyAutocompleteHandler(
        values,
        objectData,
        this.getCityAndMuncipalityList
      )
    );
  };

  autocompleteCityHandler = (values, objectData) => {
    this.setState(
      cityAndMuncipalityAutocomplete(values, objectData, this.getDistrictList)
    );
  };

  autocompleteDistrictHandler = (values, objectData) => {
    const stateCopy = this.state;

    this.setState(districtAutocompleteHandler(values, objectData), () => {
      if (
        stateCopy.newFormData[objectData.formGroup].hasOwnProperty("brPoste") &&
        values != null
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.formGroup]: {
              ...prevState.newFormData[objectData.formGroup],
              brPoste: String(values.brPoste),
            },
          },
        }));
      }
    });
  };

  getUserData = async (e) => {
    e.preventDefault();
    e.persist();

    const id = e.currentTarget.id.replace(/[^0-9]/g, "");

    const newState = { ...this.state };
    const findUserObject = newState.newFormData.reviserRegistration.find(
      (element) => {
        return element.id == id;
      }
    );

    const selectedValue = findUserObject.vrVeze;

    let identifikacija = findUserObject.oibIdBrojDrustva;
    try {
      const res = await axiosInstance.get(
        `/sifarnici/drustva?vrDrustva=${selectedValue}&identifikacija=${identifikacija}`
      );
      const { data } = res;

      if (data.length === 0) {
        return this.props.formSubmitError(true, "Nema dostupnih podataka");
      }

      let userData = {
        funkcija:1,
        vrVeze: data[0].vrDrustva,
        sifDrzave: data[0].sifDrzave.toString(),
        nazNaselja: data[0].nazNaselja || "",
        brPoste: data[0].brPoste || "",
        ulicaKbr: data[0].ulicaKbr || "",
        web: data[0].web || "",
        dataFetched: true,
        id: findUserObject.id,
        idDrustva: data[0].idDrustva.toString(),
        oibIdBrojDrustva: data[0].oib || data[0].idBroj,

        requiredFieldsReviserRegistration: ["vrVeze"],
        datPocRo: findUserObject.datPocRo,
        datPocSo: findUserObject.datPocSo,
      };

      switch (userData.vrVeze) {
        case "2":
          userData.ime = data[0].ime;
          userData.prezime = data[0].prezime;
          break;
        default:
          userData.nazDrustva = data[0].nazDrustva;
          break;
      }

      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          reviserRegistration: [
            ...prevState.newFormData.reviserRegistration.map((element) => {
              return element.id == id ? userData : element;
            }),
          ],
        },
      }));
    } catch (e) {
      throw e;
    }
  };

  multiplyComponent = (e, objData) => {
    e.persist();
    const lastElem = [...this.state.newFormData[objData.formGroup]];
    const addNewElement = objData.formGroup === "reviserRegistration" && {
      vrVeze: "",
      idDrustva: "",
      oibIdBrojDrustva: "",
      requiredFieldsReviserRegistration: ["vrVeze"],
      ime: "",
      datPocRo: "",
      datPocSo: "",
      prezime: "",
      nazDrustva: "",
      dataFetched: false,
      sifDrzave: "",
      nazNaselja: "",
      brPoste: "",
      ulicaKbr: "",
      web: "",
      id: lastElem[lastElem.length - 1].id + 1,
    };
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objData.formGroup]: [
          ...prevState.newFormData[objData.formGroup],
          addNewElement,
        ],
      },
    }));
  };

  handleDayClick = (date, dateString, objData) => {
    this.setState(handleDayPicker(dateString, objData));
  };

  userInputHandler = (e, objData) => {
    e.persist();
    // const id = e.target.id.replace(/[0-9]/g, "");
    const { name } = e.target;
    this.setState(handleUserInput(e, objData), () => {
      name === "oib" &&
        this.state.newFormData.userData.oibValidated &&
        this.fetchUserDataCoib();
    });
  };

  fetchUserDataCoib = async () => {
    const oib = this.state.newFormData.userData.oib;
    const { data } = await axiosInstance.get(`/sifarnici/oib-data/${oib}`);
    //ovo smece treba testirati
    const sifGradOpcina = data.sifraGradaOpcine.replace(/^0+/, "");
    const sifraNaselja = data.sifraNaselja.replace(/^0+/, "");

    this.getCityAndMuncipalityList(data.sifraZupanije);
    this.getDistrictList(sifGradOpcina);

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          ime: data.ime,
          prezime: data.prezime,
        },
        address: {
          ...prevState.newFormData.address,
          sifDrzave: data.sifraDrzave,
          sifZupanije: data.sifraZupanije,
          nazZupanije: data.nazivZupanije,
          sifGrdOpc: sifGradOpcina,
          nazGrdOpc: data.grad,
          sifNaselja: sifraNaselja,
          nazNaselja: data.naselje,
          brPoste: data.postanskiBroj,
          ulicaKbr: `${data.adresa} ${data.kucniBroj} ${data.kucniBrojDodatak}`,
        },
      },
    }));
  };

  removeComponentHandler = (e, objectData) => {
    e.persist();
    const lastElem = [...this.state.newFormData[objectData.formGroup]];
    const { formGroup } = objectData;
    const arrayLength = this.state.newFormData[formGroup].length;
    const id = e.currentTarget.id.replace(/[^0-9]/g, "");

    if (arrayLength > 1) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          [formGroup]: [
            ...prevState.newFormData[formGroup].filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
    } else {
      alert("Uklanjanje nije moguće!");
    }
  };

  submitHandler = async (e) => {
    const { zahtjevAtrId } = this.props;
    const stateCopy = { ...this.state.newFormData };
    const { requiredFieldsUserData } = stateCopy.userData;
    const validateUserData = validateRequiredFields(
      stateCopy.userData,
      requiredFieldsUserData
    );
    let { requiredFieldsAddress } = stateCopy.address;
    if (stateCopy.address.sifDrzave != "191") {
      requiredFieldsAddress = [
        "sifDrzave",
        // "nazZupanije",
        // "nazGrdOpc",
        "nazNaselja",
        "brPoste",
        "ulicaKbr",
      ];
    }

    const validateAddress = validateRequiredFields(
      stateCopy.address,
      requiredFieldsAddress
    );
    // const reviserRegistration = validateArrayFields(
    //   stateCopy.reviserRegistration,
    //   "requiredFieldsReviserRegistration"
    // ).every((element) => {
    //   console.log(element)
    //   return element === true;
    // });

    if (!validateUserData || !validateAddress) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    //validacija oib-a
    if (!stateCopy.userData.oibValidated) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Osnovni podaci)"
      );
      return;
    }

    const checkDatRoDatPocSo = [...stateCopy.reviserRegistration].filter(
      (element) => element.datPocRo.length < 1 && element.datPocSo.length < 1
    );
    if (checkDatRoDatPocSo.length > 0) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(
            true,
            "Unesite datum početka stručnog osposobljavanja ili datum početka radnog odnosa"
          );
        }
      );
      return;
    }

    const checkIfDataIsFetched = [...stateCopy.reviserRegistration].every(
      (element) => element.idDrustva
    );

    if (!checkIfDataIsFetched) {
      this.props.formSubmitError(
        true,
        "Dohvatite podatke o revizorskom društvu/samostalnom revizoru!"
      );
      return;
    }

    const userData = { ...stateCopy.userData };
    delete userData.requiredFieldsUserData;
    delete userData.oibValidated;
    delete userData.oznAkt;

    const address = { ...stateCopy.address };
    delete address.nazivDrzave;
    delete address.requiredFieldsAddress;

    const revReg = [...this.state.newFormData.reviserRegistration].map(
      (element) => {
        return {
          // vrVeze: element.vrVeze,
          vrVeze: "2",
          idDrustva: element.idDrustva,
          oibDrustva: element.oibDrustva,
          datPocRo: element.datPocRo,
          datPocSo: element.datPocSo,
        };
      }
    );

    const { oznDokumenta } = this.state.newFormData;

    const submitData = [4, userData, address, revReg, oznDokumenta];

    try {
      this.setState({
        loader: true,
      });
      if (!this.state.update) {
        const res = await axiosInstance
          .post(`/unos/${zahtjevAtrId}`, submitData)
          .then(() =>
            this.setState({
              loader: false,
            })
          );
        this.props.formSubmitSuccess(
          false,
          "Podaci o subjektu uspješno upisani."
        );
        this.props.history.push("/odobrenje-zahtjeva");
        return;
      }
      const res = await axiosInstance.patch("/edit", submitData).then(() =>
        this.setState({
          loader: false,
        })
      );
      this.props.formSubmitSuccess(false, "Podaci uspješno ažurirani.");
      this.props.history.push("/pregled-registara");
    } catch (e) {
      this.props.formSubmitError(
        true,
        e.response.data.message ||
        "Nešto je pošlo po krivu, provjerite unesene podatke!"
      );
      this.setState({
        loader: false,
      });
    }
  };

  render() {
    const otherProps = {
      parentState: this.state,
      userInputHandler: this.userInputHandler,
      autocompleteCountryHandler: this.autocompleteCountryHandler,
      autocompleteCountyHandler: this.autocompleteCountyHandler,
      mappedUserInputHandler: this.mappedUserInputHandler,
      autocompleteCityHandler: this.autocompleteCityHandler,
      autocompleteDistrictHandler: this.autocompleteDistrictHandler,
      dropdownHandler: this.dropdownHandler,
      getUserData: this.getUserData,
      submitHandler: this.submitHandler,
      handleDayClick: this.handleDayClick,
      multiplyComponent: this.multiplyComponent,
      removeComponentHandler: this.removeComponentHandler,
    };

    return (
      <>
        {this.state.requestsLoaded ? (
          <EntryForm4 {...otherProps} />
        ) : (
          <Spinner />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    zahtjevAtrId: state.formData.zahtjevAtrId,
    idOsobe: state.update.idOsobe,
    vrOsobe: state.update.vrOsobe,
    oznDokumenta: state.update.oznDokumenta,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
    purgeUpdate: () => dispatch({ type: PURGE_UPDATE }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistarRevizorskihVjezbenika);
